// #region imports

// --- Angular
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

// --- 3rd Party
import { ImageCropperModule } from 'ngx-image-cropper';
import { InViewportModule } from '@hkjeffchan/angular-inviewport';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SimplebarAngularModule } from 'simplebar-angular';
import { TranslateModule } from '@ngx-translate/core';

// --- HS Code
import * as c from './';
import * as dir from './directives';
import * as pipes from './pipes';
import * as dashC from '../dashboard';
import {PlatformModule} from "@angular/cdk/platform";

// #endregion

@NgModule({
  declarations: [
    c.AddJournalComponent,
    c.AddJournalEntryComponent,
    c.AddRespondentComponent,
    c.AutocompleteBoxComponent,
    c.AutocompleteDropdownComponent,
    c.AvatarComponent,
    c.BadgeComponent,
    c.ButtonLoaderComponent,
    c.CharacterCounterComponent,
    c.DemographicsComponent,
    c.EditboxComponent,
    c.FieldErrorComponent,
    c.FieldHintComponent,
    c.HeroImageComponent,
    c.InlineEditorComponent,
    c.InvitePreviousRespondentsV2Component,
    c.LanguagePickerComponent,
    c.LanguageSelectControlComponent,
    c.LoaderComponent,
    c.LogoNavComponent,
    c.OnlineStatusComponent,
    c.PinJournalComponent,
    c.PolicyNavLinksComponent,
    c.PortalComponent,
    c.PrivacyPolicyComponent,
    c.ProgressBarComponent,
    c.ResultsLockedComponent,
    c.ShellComponent,
    c.ShowHideMoreTextComponent,
    c.TermsAndConditionsComponent,
    c.TermsAndConditionsFormComponent,
    c.TermsAndConditionsModalComponent,
    c.ToggleIconComponent,
    c.UndoSnackBarComponent,
    c.UserAvatarComponent,
    c.VideoPlayerComponent,
    c.RespondentOptionsBottomSheetComponent,
    dir.DisableControlDirective,
    dir.HighlightTextDirective,
    pipes.AvatarTextPipe,
    pipes.CapitalizePipe,
    pipes.HighlightWordPipe,
    pipes.TimeAgoPipe,
    pipes.TimeRemainingPipe,

    // Dashboard Shared Components
    dashC.DashboardSideNavComponent,
    dashC.DashboardSideNavLinksComponent,
    dashC.DashboardTopNavComponent,
    dashC.DashboardTopNavMobileComponent,
    dashC.NotificationListComponent,
    dashC.NotificationListEmptyComponent,
    dashC.NotificationListItemComponent,
    dashC.NotificationModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ImageCropperModule,
    InViewportModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    NgbModule,
    ReactiveFormsModule,
    RouterModule,
    SimplebarAngularModule,
    TranslateModule,
    MatBottomSheetModule,
    PlatformModule,
  ],
  providers: [
    DecimalPipe,
    Title
  ],
  exports: [
    c.AddJournalComponent,
    c.AddJournalEntryComponent,
    c.AddRespondentComponent,
    c.AutocompleteBoxComponent,
    c.AutocompleteDropdownComponent,
    c.AvatarComponent,
    c.BadgeComponent,
    c.ButtonLoaderComponent,
    c.CharacterCounterComponent,
    c.DemographicsComponent,
    c.EditboxComponent,
    c.FieldErrorComponent,
    c.FieldHintComponent,
    c.HeroImageComponent,
    c.InlineEditorComponent,
    c.InvitePreviousRespondentsV2Component,
    c.LanguagePickerComponent,
    c.LanguageSelectControlComponent,
    c.LoaderComponent,
    c.LogoNavComponent,
    c.OnlineStatusComponent,
    c.PinJournalComponent,
    c.PortalComponent,
    c.ProgressBarComponent,
    c.ResultsLockedComponent,
    c.ShowHideMoreTextComponent,
    c.TermsAndConditionsFormComponent,
    c.TermsAndConditionsModalComponent,
    c.ToggleIconComponent,
    c.UndoSnackBarComponent,
    c.UserAvatarComponent,
    c.VideoPlayerComponent,
    c.RespondentOptionsBottomSheetComponent,
    dir.DisableControlDirective,
    dir.HighlightTextDirective,

    // Dashboard Shared Components
    dashC.DashboardSideNavComponent,
    dashC.DashboardSideNavLinksComponent,
    dashC.DashboardTopNavComponent,
    dashC.DashboardTopNavMobileComponent,
    dashC.NotificationListComponent,
    dashC.NotificationListEmptyComponent,
    dashC.NotificationListItemComponent,
    dashC.NotificationModalComponent,

    FormsModule,
    ImageCropperModule,
    InViewportModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    NgbModule,
    NgxSpinnerModule,
    pipes.AvatarTextPipe,
    pipes.CapitalizePipe,
    pipes.HighlightWordPipe,
    pipes.TimeAgoPipe,
    pipes.TimeRemainingPipe,
    ReactiveFormsModule,
    RouterModule,
    SimplebarAngularModule,
    TranslateModule,
    MatBottomSheetModule
  ]
})
export class SharedModule { }
